import { lookupCard } from "../../content/index.js";
import { applyCardEffects } from "./applyEffect.js";
import { canSpendEnergy, spendEnergy } from "./spendEnergy.js";
import type { ActiveCase, CardInstance, CardInstanceId, RunState } from "../types/index.js";
import { removeFromHand } from "../run/discardPlayed.js";

export type PlayCardResult =
  | { ok: true; run: RunState; activeCase: ActiveCase; reshuffled: boolean }
  | { ok: false; reason: string };

export function playCard(
  run: RunState,
  activeCase: ActiveCase,
  instanceId: CardInstanceId,
): PlayCardResult {
  if (run.pendingChoice) {
    return { ok: false, reason: "選択待ち中はカードを使用できない" };
  }

  const { hand, card } = removeFromHand(run.hand, instanceId);
  if (!card) return { ok: false, reason: "手札にカードがない" };

  const def = lookupCard(card.cardId);
  if (!def || def.type === "worker") {
    return { ok: false, reason: "労働者カードは使用できない" };
  }
  if (!canSpendEnergy(run, activeCase)) {
    return { ok: false, reason: "行動数が不足している" };
  }

  const spent = spendEnergy(run, activeCase);
  if (!spent) return { ok: false, reason: "行動数が不足している" };

  let nextRun: RunState = {
    ...spent.run,
    hand,
    inPlay: [...spent.run.inPlay, card],
  };

  const result = applyCardEffects(
    { run: nextRun, activeCase: spent.activeCase, sourceInstanceId: instanceId },
    def.effect,
  );

  return {
    ok: true,
    run: result.run,
    activeCase: result.activeCase,
    reshuffled: Boolean(result.reshuffled),
  };
}

export function playRevealedAction(
  run: RunState,
  activeCase: ActiveCase,
  card: CardInstance,
): { run: RunState; activeCase: ActiveCase; reshuffled: boolean } {
  const nextRun: RunState = {
    ...run,
    inPlay: [...run.inPlay, card],
  };
  const def = lookupCard(card.cardId);
  if (!def?.effect) return { run: nextRun, activeCase, reshuffled: false };

  const result = applyCardEffects(
    { run: nextRun, activeCase, sourceInstanceId: card.instanceId },
    def.effect,
  );
  return {
    run: result.run,
    activeCase: result.activeCase,
    reshuffled: Boolean(result.reshuffled),
  };
}
